import { render } from "./SidebarInset.vue?vue&type=template&id=4bc4a3ec&ts=true"
import script from "./SidebarInset.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarInset.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/sidebar/SidebarInset.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4bc4a3ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4bc4a3ec', __exports__)) {
    api.reload('4bc4a3ec', __exports__)
  }
  
  module.hot.accept("./SidebarInset.vue?vue&type=template&id=4bc4a3ec&ts=true", () => {
    api.rerender('4bc4a3ec', render)
  })

}


export default __exports__